import React from 'react';
import { Button } from '@theme/js/components/common/Button';
import { ManagedPopup } from '@core/js/components/common/Popup';
import { I18n } from '@core/js/components/common/I18n';
import { useTranslations } from '@core/js/hooks/i18n';
import { useCombinedOnClose } from '@theme/js/components/common/PopupManager';

import style from './AgeVerificationPopup.scss';

export const popupClassNames = {
    inner: style.popupInner
};

export const AgeVerificationPopup = ({ onClose, controls }) => {
    const t = useTranslations('playtech.mobile.system.age-verification.');
    const title = t('title');
    const closePopup = useCombinedOnClose(onClose);

    /* TotalCasino changes */
    return (
        <ManagedPopup title={title} classNames={popupClassNames} isModal={true} controls={controls}>
            <p><I18n t={t} tKey={'description'} /></p>
            <p className={style.ageVerificationButton}>
                <Button
                    type="button"
                    view="primary"
                    onClick={closePopup}
                    className={style.ageConfirmButton}
                >
                    {t('submit')}
                </Button>
            </p>
        </ManagedPopup>
    );
    /* TotalCasino changes */
};
